export default __webpack_public_path__ + "static/media/android_app_link.ae4a0046.png";